// src/components/forms/FileUpload.js

import React, { useRef, useState } from 'react';
import { formatFileSize } from '../../utils/helpers';

const FileUpload = ({ label, required, accept = '*', onChange, error, hint }) => {
  const ref = useRef();
  const [file, setFile] = useState(null);
  const [dragging, setDragging] = useState(false);

  const handleFile = (f) => {
    if (!f) return;
    setFile(f);
    if (onChange) onChange(f);
  };

  return (
    <div className="form-group">
      {label && (
        <label className="form-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      {hint && <p style={{ fontSize: '0.8rem', color: 'var(--gray-400)', marginBottom: '0.5rem' }}>{hint}</p>}
      <div
        className={`upload-area ${dragging ? 'dragging' : ''} ${error ? 'error' : ''}`}
        style={{ border: error ? '2px dashed var(--danger)' : undefined }}
        onClick={() => ref.current.click()}
        onDragOver={e => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={e => { e.preventDefault(); setDragging(false); handleFile(e.dataTransfer.files[0]); }}
      >
        <input
          ref={ref}
          type="file"
          accept={accept}
          onChange={e => handleFile(e.target.files[0])}
        />
        {file ? (
          <div>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📄</div>
            <p className="upload-success">
              <strong>{file.name}</strong>
            </p>
            <p style={{ fontSize: '0.8rem', color: 'var(--gray-400)', marginTop: '0.25rem' }}>
              {formatFileSize(file.size)} — clique para trocar
            </p>
          </div>
        ) : (
          <div>
            <div className="upload-icon">📎</div>
            <p className="upload-label">
              <strong>Arraste o arquivo</strong> ou clique para selecionar
            </p>
            {accept !== '*' && (
              <p style={{ fontSize: '0.75rem', color: 'var(--gray-400)', marginTop: '0.25rem' }}>
                Aceitos: {accept}
              </p>
            )}
          </div>
        )}
      </div>
      {error && <p className="form-error">{error}</p>}
    </div>
  );
};

export default FileUpload;
